import React from 'react';
import { Avatar } from '@chakra-ui/react';
import { constant } from 'constant';
import { getAvatarColor, getInitials } from 'utils/colorUtils';

/**
 * The face on an outbound message.
 *
 * ★ WHY THIS IS NOT `AgentAvatar` FROM THE CALL DASHBOARD.
 * That one exists and does the same job, but it is painted from the dashboard's
 * own palette object rather than the theme, and the inbox is built entirely on
 * `wa.*` semantic tokens — importing it would drag a second colour system into
 * the one screen that has stayed on one. The two pieces worth sharing are
 * shared: `getAvatarColor` and `getInitials` from `utils/colorUtils`, so a
 * person's colour is the same here as everywhere else in the CRM.
 *
 * ★ A PATH, NOT A URL. `profileImage` is stored on the user as a relative path;
 * every avatar in this product prefixes it with the API base. A missing photo
 * is the normal case, not a failure — Chakra falls back to the initials, which
 * is why the colour has to be deterministic rather than random.
 */
export default function SenderAvatar({ name = '', profileImage = null, size = 'xs' }) {
	const src = profileImage ? `${constant.baseUrl}${profileImage}` : undefined;
	const color = getAvatarColor(name);

	return (
		<Avatar
			size={size}
			name={name}
			src={src}
			bg={color}
			color="text.onAccent"
			// Chakra's own initials take three words; the CRM's take two, and two
			// is what fits an avatar this small.
			getInitials={() => getInitials(name)}
			flexShrink={0}
		/>
	);
}
